import RestaurantsScrollableList from 'components/Lists/ListView/RestaurantsScrollableList';
import Text from 'components/Text/Text';
import React from 'react';
import { IItemComboGroup } from 'types';
import classNames from 'classnames';
import ComboItemsScrollView from './components/ComboItemsScrollView';
import DishesScrollView from './components/DishesScrollView';
import style from './Info.module.scss';

interface IInfo {
	isOpenInfo: boolean;
	data: IItemComboGroup;
}

const Info: React.FC<IInfo> = ({ isOpenInfo, data }) => {
	const containerClasses = classNames(style.container, { [style.visible]: isOpenInfo });

	const restaurants = data.restaurants.map((el) => ({
		...el,
		id: el.restaurantId,
	}));

	return (
		<div className={containerClasses} data-test="Info">
			<div className={style.wrapper}>
				<div className={style.infoContainer}>
					<div className={style.block}>
						<Text
							className={style.blockName}
							translationNameSpace="listing"
							translationKey="comboGroupLabel"
							theme="neutralLight"
						/>
						<Text className={style.blockValue} translationKey={data.name} withTooltip={true} />
						<Text
							className={style.blockName}
							translationNameSpace="listing"
							translationKey="customerLabel"
							theme="neutralLight"
						/>
						<Text className={style.blockValue} translationKey={data.customer.name} withTooltip={true} />
						<Text
							className={style.blockName}
							translationNameSpace="listing"
							translationKey="positionLabel"
							theme="neutralLight"
						/>
						{/* TODO replace when added on BE */}
						<Text className={style.blockValue} translationKey="-" withTooltip={true} />
					</div>
					<div className={style.block}>
						<Text
							className={style.blockName}
							translationNameSpace="listing"
							translationKey="restaurantLabel"
							theme="neutralLight"
						/>
						<div className={style.blockValue}>
							<RestaurantsScrollableList restaurants={restaurants} />
						</div>
					</div>
					<div className={style.block}>
						<Text
							className={style.blockName}
							translationNameSpace="listing"
							translationKey="dishLabel"
							theme="neutralLight"
						/>
						<div className={style.blockValue}>
							<DishesScrollView data={data.dishes} />
						</div>
					</div>
					<div className={style.block}>
						<Text
							className={style.blockName}
							translationNameSpace="listing"
							translationKey="comboItemLabel"
							theme="neutralLight"
						/>
						<div className={style.blockValue}>
							<ComboItemsScrollView data={data.comboItems} />
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default React.memo(Info);
